export const CRUCIBLE_CONTRACTS_V_0_1: any = {
  RINKEBY: {
    factory: "0x2E15Ad5a416BC23ad80B6A1882e885b797a78CaF",
    router: "0xfE31f63BCd6Dd0297649Bb384ef2C89149c16A76",
    staking: "",
  },
  BSC_TESTNET: {
    factory: "0x2E15Ad5a416BC23ad80B6A1882e885b797a78CaF",
    router: "0xfE31f63BCd6Dd0297649Bb384ef2C89149c16A76",
    staking: "",
  },
  BSC: {
    factory: "0x0913bAD94A4008a23C679ddF1cF11B6A391bF628",
    router: "0x476F21e9c9787A76cdD7f25dd6Db4039c0ad3176",
    staking: "",
  },
  ETHEREUM: {
    factory: "",
    router: "",
    staking: "",
  },
  POLYGON: {
    factory: "0x2E15Ad5a416BC23ad80B6A1882e885b797a78CaF",
    router: "0xfE31f63BCd6Dd0297649Bb384ef2C89149c16A76",
    staking: "",
  },
  ARBITRUM: {
    factory: "0xd138ba4c9A04eBE9CEDF23161a76057fA800B017",
    router: "0xD2ad2e820Df8b5F55074b73fb1Fb821d8eCaDEfb",
    staking: "",
  },
};

export const STEP_FLOW_IDS: any = {
  cFRM_BNB: {
    dashboard: {
      id: "6238314dd292da2db05524dd",
      name: "cFRM / BNB Crucible Farm - Farming Dashboard Flow",
    },
    mint: {
      id: "6239951af0f70e3848644311",
      name: "cFRM / BNB Crucible Farm - Mint Flow",
    },
    mintAndStake: {
      id: "6239951af0f70e3848644311",
      name: "cFRM / BNB Crucible Farm - Staking Mint Flow",
    },
    generalAddLiquidity: {
      id: "623b7111f0f70e38486448fd",
      name: "cFRM / BNB Crucible Farm - Add Liquidity - General Flow",
    },
    stake: {
      id: "6239953cf0f70e3848644314",
      name: "cFRM / BNB Crucible Farm - Stake Flow",
    },
    unstake: {
      id: "62399544f0f70e3848644317",
      name: "cFRM / BNB Crucible Farm - Unstake Flow",
    },
    unstakeRemoveLiquidity: {
      id: "623b71ccf0f70e3848644900",
      name: "cFRM / BNB Crucible Farm - Remove Liquidity - Unstake Flow",
    },
    withdraw: {
      id: "6239954ef0f70e384864431a",
      name: "cFRM / BNB Crucible Farm - Withdraw Flow",
    },
    withdrawAddLiquidity: {
      id: "623b720ff0f70e3848644903",
      name: "cFRM / BNB Crucible Farm - Add Liquidity - Withdraw Flow",
    },
    unwrap: {
      id: "62399559f0f70e384864431d",
      name: "cFRM / BNB Crucible Farm - Unwrap Flow",
    },
  },
  cFRM: {
    dashboard: {
      id: "6238386bd292da2db05524f9",
      name: "cFRM Crucible Farm - Farming Dashboard Flow",
    },
    mint: {
      id: "623b5f46f0f70e3848644832",
      name: "cFRM Crucible Farm - Mint Flow",
    },
    generalAddLiquidity: {
      id: "623b5ffbf0f70e3848644838",
      name: "cFRM Crucible Farm - Add Liquidity - General Flow",
    },
    mintAndStake: {
      id: "6514242c8c616b1efd8d649e",
      name: "cFRM Crucible Farm - Staking Mint Flow",
    },
    stake: {
      id: "623b6018f0f70e384864483b",
      name: "cFRM Crucible Farm - Stake Flow",
    },
    unstake: {
      id: "623b602cf0f70e384864483e",
      name: "cFRM Crucible Farm - Unstake Flow",
    },
    unstakeAddLiquidity: {
      id: "623b65c2f0f70e3848644854",
      name: "cFRM Crucible Farm - Add Liquidity - Unstake Flow",
    },
    withdraw: {
      id: "623b65d5f0f70e3848644857",
      name: "cFRM Crucible Farm - Withdraw Flow",
    },
    withdrawAddLiquidity: {
      id: "623b65e9f0f70e384864485a",
      name: "cFRM Crucible Farm - Add Liquidity - Withdraw Flow",
    },
    unwrap: {
      id: "623b661cf0f70e384864485d",
      name: "cFRM Crucible Farm - Unwrap Flow",
    },
  },
  cLEO: {
    dashboard: {
      id: "6238386bd292da2db05524f9",
      name: "cLEO Crucible Farm - Farming Dashboard Flow",
    },
    mint: {
      id: "64df9fa8df6cb722a0cdffcb",
      name: "cLEO Crucible Farm - Mint Flow",
    },
    generalAddLiquidity: {
      id: "64dfa051df6cb722a0ce016e",
      name: "cLEO Crucible Farm - Add Liquidity - General Flow",
    },
    mintAndStake: {
      id: "64df9fcadf6cb722a0ce0073",
      name: "cLEO Crucible Farm - Staking Mint Flow",
    },
    stake: {
      id: "64dfa2cddf6cb722a0ce0657",
      name: "cLEO Crucible Farm - Stake Flow",
    },
    unstake: {
      id: "64dfa897df6cb722a0ce097c",
      name: "cLEO Crucible Farm - Unstake Flow",
    },
    unstakeAddLiquidity: {
      id: "64df9fefdf6cb722a0ce00a5",
      name: "cLEO Crucible Farm - Add Liquidity - Unstake Flow",
    },
    withdraw: {
      id: "64dfab91df6cb722a0ce09f6",
      name: "cLEO Crucible Farm - Withdraw Flow",
    },
    withdrawAddLiquidity: {
      id: "64dfa071df6cb722a0ce017d",
      name: "cLEO Crucible Farm - Add Liquidity - Withdraw Flow",
    },
    unwrap: {
      id: "64dfa004df6cb722a0ce00df",
      name: "cLEO Crucible Farm - Unwrap Flow",
    },
  },
  cTestFrm: {
    dashboard: {
      id: "63f8d6b55341c32c5281d6c2",
      name: "cTestFrm Crucible Farm - Farming Dashboard Flow",
    },
    mint: {
      id: "63f8d8f35341c32c5281d6d4",
      name: "cTestFrm Crucible Farm - Mint Flow",
    },
    generalAddLiquidity: {
      id: "63f8de965341c32c5281d6f8",
      name: "cTestFrm Crucible Farm - Add Liquidity - General Flow",
    },
    mintAndStake: {
      id: "651426b18c616b1efd8d6560",
      name: "cTestFrm Crucible Farm - Staking Mint Flow",
    },
    stake: {
      id: "63f8defb5341c32c5281d703",
      name: "cTestFrm Crucible Farm - Stake Flow",
    },
    unstake: {
      id: "63f8dfbf5341c32c5281d71c",
      name: "cTestFrm Crucible Farm - Unstake Flow",
    },
    unstakeAddLiquidity: {
      id: "63f8e0425341c32c5281d72e",
      name: "cTestFrm Crucible Farm - Add Liquidity - Unstake Flow",
    },
    withdraw: {
      id: "63f8e09a5341c32c5281d739",
      name: "cTestFrm Crucible Farm - Withdraw Flow",
    },
    withdrawAddLiquidity: {
      id: "63f8e12c5341c32c5281d74b",
      name: "cTestFrm Crucible Farm - Add Liquidity - Withdraw Flow",
    },
    unwrap: {
      id: "63f8e1795341c32c5281d756",
      name: "cTestFrm Crucible Farm - Unwrap Flow",
    },
  },
  cFRMx: {
    dashboard: {
      id: "62383865d292da2db05524f6",
      name: "cFRMx Crucible Farm - Farming Dashboard Flow",
    },
    mint: {
      id: "623b7bf1f0f70e38486449a9",
      name: "cFRMx Crucible Farm - Mint Flow",
    },
    generalAddLiquidity: {
      id: "623b7d46f0f70e38486449c9",
      name: "cFRMx Crucible Farm - Add Liquidity - General Flow",
    },
    mintAndStake: {
      id: "623b7bf1f0f70e38486449a9",
      name: "cFRMx Crucible Farm - Staking Mint Flow",
    },
    stakingMint: {
      id: "623b7c2cf0f70e38486449b1",
      name: "cFRMx Crucible Farm - Staking Mint Flow",
    },
    stake: {
      id: "623b7d5cf0f70e38486449cc",
      name: "cFRMx Crucible Farm - Stake Flow",
    },
    unstake: {
      id: "623b7d75f0f70e38486449cf",
      name: "cFRMx Crucible Farm - Unstake Flow",
    },
    unstakeAddLiquidity: {
      id: "623b7f36f0f70e38486449d2",
      name: "cFRMx Crucible Farm - Add Liquidity - Unstake Flow",
    },
    withdraw: {
      id: "623b7f51f0f70e38486449d5",
      name: "cFRMx Crucible Farm - Withdraw Flow",
    },
    withdrawAddLiquidity: {
      id: "623b7f85f0f70e38486449d8",
      name: "cFRMx Crucible Farm - Add Liquidity - Withdraw Flow",
    },
    unwrap: {
      id: "623b8016f0f70e38486449de",
      name: "cFRMx Crucible Farm - Unwrap Flow",
    },
  },
  cFRMx_BNB: {
    dashboard: {
      id: "62383841d292da2db05524f3",
      name: "cFRMx / BNB Crucible Farm - Farming Dashboard Flow",
    },
    mint: {
      id: "623b90c2f0f70e3848644a65",
      name: "cFRMx / BNB Crucible Farm - Mint Flow",
    },
    generalAddLiquidity: {
      id: "623b9104f0f70e3848644a68",
      name: "cFRMx / BNB Crucible Farm - Add Liquidity - General Flow",
    },
    stake: {
      id: "623b9134f0f70e3848644a6b",
      name: "cFRMx / BNB Crucible Farm - Stake Flow",
    },
    unstake: {
      id: "623b9152f0f70e3848644a6e",
      name: "cFRMx / BNB Crucible Farm - Unstake Flow",
    },
    mintAndStake: {
      id: "623b90c2f0f70e3848644a65",
      name: "cFRMx / BNB Crucible Farm - Staking Mint Flow",
    },
    unstakeRemoveLiquidity: {
      id: "623b917cf0f70e3848644a71",
      name: "cFRMx / BNB Crucible Farm - Remove Liquidity - Unstake Flow",
    },
    withdraw: {
      id: "623b919af0f70e3848644a74",
      name: "cFRMx / BNB Crucible Farm - Withdraw Flow",
    },
    withdrawAddLiquidity: {
      id: "623b91baf0f70e3848644a77",
      name: "cFRMx / BNB Crucible Farm - Add Liquidity - Withdraw Flow",
    },
    unwrap: {
      id: "623b91d9f0f70e3848644a7a",
      name: "cFRMx / BNB Crucible Farm - Unwrap Flow",
    },
  },
};

export const getBaseTokenName = (farm: any) => {
  if (farm === "cFRM" || farm === "cFRM-BNB") {
    return "FRM";
  } else if (farm === "cFRMx" || farm === "cFRMx-BNB") {
    return "FRMx";
  } else if (farm === "cTestFrm") {
    return "FRM";
  } else if (farm === "cLEO") {
    return "LEO";
  }
};

export const getCrucibleTokenName = (farm: any) => {
  if (farm === "cFRM" || farm === "cFRM-BNB") {
    return "cFRM";
  } else if (farm === "cFRMx" || farm === "cFRMx-BNB") {
    return "cFRMx";
  } else if (farm === "cTestFrm") {
    return "cFRM";
  } else if (farm === "cFRM-ARBITRUM") {
    return "cFRM";
  } else if (farm === "cLEO") {
    return "cLEO";
  }
};

export const Crucible_Farm_Address_Details: any = {
  cFRM: {
    DashboardStepFlowId: "6238386bd292da2db05524f9",
    network: "BSC",
    internalName: "cFRM",
    contract: "0xaf329a957653675613D0D98f49fc93326AeB36Fc",
    LpCurrency: "0x9aa0AB73409311984ED84f3Edef962201Bd11712",
    LPstakingAddress: "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008",
    isMintAndStakeAllowed: true,
  },
  cLEO: {
    DashboardStepFlowId: "6238386bd292da2db05524f9",
    network: "BSC",
    internalName: "cLEO",
    contract: "0xa8E0F56027313c7b1F11048Bd0757243ca654CbD",
    LpCurrency: "0x9aa0AB73409311984ED84f3Edef962201Bd11712",
    LPstakingAddress: "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008",
    isMintAndStakeAllowed: true,
  },
  cFRMx: {
    DashboardStepFlowId: "62383865d292da2db05524f6",
    internalName: "cFRMx",
    contract: "0x1fC45F358D5292bEE1e055BA7CebE4d4100972AE",
    network: "BSC",
    LpCurrency: "0xb76b11410A506495418D20c58F9452c17CF285c1",
    LPstakingAddress: "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008",
    isMintAndStakeAllowed: false,
  },
  cTestFrm: {
    DashboardStepFlowId: "6238386bd292da2db05524f9",
    network: "ETHEREUM_ARBITRUM",
    internalName: "cTestFrm",
    contract: "0xe685d3CC0be48BD59082eDe30C3b64CbFc0326e2",
    LpCurrency: "0xe685d3CC0be48BD59082eDe30C3b64CbFc0326e2",
    LPstakingAddress: "0xB4927895cbEE88E651e0582893051b3B0f8D7DB8",
    isMintAndStakeAllowed: false,
  },
  "cFRM-BNB": {
    DashboardStepFlowId: "6238314dd292da2db05524dd",
    network: "BSC",
    internalName: "cFRM-BNB",
    contract: "0xaf329a957653675613D0D98f49fc93326AeB36Fc", // crucible contract address
    LpCurrency: "0x9aa0AB73409311984ED84f3Edef962201Bd11712", // CAKE-LP token for crucible and bnb pair
    LPstakingAddress: "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008",
    isMintAndStakeAllowed: false,
  },
  "cFRMx-BNB": {
    DashboardStepFlowId: "62383841d292da2db05524f3",
    network: "BSC",
    internalName: "cFRMx-BNB",
    contract: "0x1fC45F358D5292bEE1e055BA7CebE4d4100972AE",
    LpCurrency: "0xb76b11410A506495418D20c58F9452c17CF285c1",
    LPstakingAddress: "0x35E15ff9eBB37D8C7A413fD85BaD515396DC8008",
    isMintAndStakeAllowed: false,
  },
};

export const Crucible_Balance_Tokens = {
  ferrum: [
    {
      network: 56,
      token: "cFRM",
      label: "cFRM",
    },
    {
      network: 42161,
      token: "cTestFrm",
      label: "cFRM",
    },
  ],
  "alcazar.": [
    {
      network: 56,
      token: "LEO",
      label: "LEO",
    },
    {
      network: 56,
      token: "cLEO",
      label: "cLEO",
    },
  ],
  // "APELPCFRMBNB",
  // "APELPCFRMxBNB"
};
